module.exports = __webpack_public_path__ + "img/e-learning.7abdbf20.svg";